export default function remapRange(OldMin:number, OldMax:number, NewMin:number, NewMax:number, value:number):number {
    return ((value - OldMin) * (NewMax - NewMin)) / (OldMax - OldMin) + NewMin
}
